export default "<input [(ngModel)]=\"selected\"\r\n       [typeahead]=\"states\"\r\n       class=\"form-control\">\r\n";